import "keen-slider/keen-slider.min.css"
import { useKeenSlider } from "keen-slider/react"

export default function Carousel() {
    const [sliderRef, instanceRef] = useKeenSlider({
        loop: true,
        slides: {
            perView: 1,
            spacing: 20,
        },
        breakpoints: {
            '(min-width: 640px)': {
                slides: {
                    perView: 2,
                    spacing: 25,
                },
            },
            '(min-width: 768px)': {
                slides: {
                    perView: 3,
                    spacing: 30,
                },
            },
            '(min-width: 1024px)': {
                slides: {
                    perView: 3,
                    spacing: 30,
                },
            },
            '(min-width: 1080px)': {
                slides: {
                    perView: 4,
                    spacing: 35,
                },
            },
            '(min-width: 1280px)': {
                slides: {
                    perView: 5,
                    spacing: 45,
                },
            },
        },
    })


    const prev = () => instanceRef.current?.prev()
    const next = () => instanceRef.current?.next()

    const solution = ['High cost per hire', 'Slow time to hire', 'Talent leakage', 'Under Leveraged networks', 'Siloed teams']

    return (
        <>
            <p className="font-oxanium text-center font-medium px-6 text-white text-4xl mb-12">Solutions to <span className="text-[#04D1D6]">Key Challenges</span></p>
            <div className="relative max-w-7xl mx-auto px-6 mb-28">
                <div ref={sliderRef} className="max-w-56 sm:max-w-lg md:max-w-xl lg:max-w-4xl xl:max-w-5xl mx-auto keen-slider h-[100px] rounded-xl overflow-hidden">
                    {solution.map((item, index) => {
                        return (
                            <div key={index} className="keen-slider__slide flex items-center text-sm justify-center text-center text-white font-oxanium font-medium p-6 rounded-[36px] bg-gradient-to-b from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0.05)] border border-t-0 border-l-0 border-b-[rgba(0,170,108,0.5)] border-r-[rgba(0,170,108,0.5)]">
                                {item}
                            </div>
                        )
                    })}
                </div>

                <button
                    onClick={prev}
                    className="absolute left-6 top-1/2 -translate-y-1/2 shadow-md rounded-full px-5 py-4 bg-[linear-gradient(to_right,rgba(255,255,255,0.1),rgba(255,255,255,0.05))] hover:bg-[linear-gradient(to_right,rgba(255,255,255,0.2),rgba(255,255,255,0.1))]"
                >
                    <img src="/arrow-icon.png" alt="" className="h-4 w-2" />
                </button>
                <button
                    onClick={next}
                    className="absolute right-6 top-1/2 -translate-y-1/2 shadow-md rounded-full px-5 py-4 bg-[linear-gradient(to_right,rgba(255,255,255,0.1),rgba(255,255,255,0.05))] hover:bg-[linear-gradient(to_right,rgba(255,255,255,0.2),rgba(255,255,255,0.1))]"
                >
                    <img src="/arrow-icon.png" alt="" className="h-4 w-2 rotate-180" />
                </button>
            </div>
        </>
    )
}
